import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetPageHomeStyle0 = gravityIconIndividualCss;

const GravityIconAssetPageHome = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'd50a5907f86940d5f8f28d3db22a56db3ff526a2', color: this.color, size: this.size }, h("svg", { key: 'c9dc88e9b8d80f87a4730e637b01a63eea965614', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '6e5197b7c350a85b5e36b4a680f376ab18100a8f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.5 10.25c-.126.114-.25.33-.25.5v4.5c0 .167.086.25.253.25H9.5c.166 0 .25-.084.25-.25v-3c0-.166.084-.35.25-.35h2c.194 0 .25.17.25.35v3c0 .166.085.25.25.25h3c.166 0 .25-.084.25-.25v-4.5c0-.17-.124-.386-.25-.5L11.2 6.5a.3.3 0 0 0-.4 0l-4.3 3.75Z", fill: "currentColor" }), h("path", { key: 'd37ea68370d555ea69655384652a22ba8e1535be', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17c.276 0 .5.21.5.471V17.53c0 .26-.224.471-.5.471h-17c-.276 0-.5-.21-.5-.471V4.47c0-.26.224-.471.5-.471Zm16 12.5v-11h-15v11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetPageHome.style = GravityIconAssetPageHomeStyle0;

export { GravityIconAssetPageHome as gravity_icon_asset_page_home };

//# sourceMappingURL=gravity-icon-asset-page-home.entry.js.map